import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { DraasApiConfig } from '@pure1/data';
import { isPure1Production } from './utils/url';
import { ampli } from './ampli';
import { resolveBootstrapOrgContext } from './app/resolve-bootstrap-org-context';
import { BOOTSTRAP_ORG_CONTEXT } from './data/services/effective-org.service';

window['amplitude'] = ampli;
// an alias to support the Appcues integration which depends on the legacy "logEvent" method
window['amplitude'].logEvent = window['amplitude'].track;

if (environment.production) {
    enableProdMode();
}

if (!isPure1Production()) {
    window['draasApi'] = DraasApiConfig.initialize();
}

// Resolve the effective org before Angular starts, so every request (including those made while
// services are constructed) carries X-ORG-UIDS / X-LEGACY-ORG-IDS. See docs/bootstrap.md.
resolveBootstrapOrgContext(window)
    .then(orgContext =>
        platformBrowser([{ provide: BOOTSTRAP_ORG_CONTEXT, useValue: orgContext }]).bootstrapModule(AppModule, {
            // One change detection per frame for all the listeners a single DOM event reaches, instead of
            // one per listener. The Hive 7 app navigation puts capture-click, focusin/focusout and
            // mouseenter/mouseleave listeners on every rail item, so one click on the rail otherwise runs
            // a full tick of the page it is leaving for each of them.
            applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true })],
            preserveWhitespaces: true,
        }),
    )
    .catch(err => {
        console.log('Failed to bootstrap Angular', err);
    });
